class WebsiteTableRow {
    id;
    name;
    url;
    default_language;
    languages = [];
    active;
    api_key;
    customer;

    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.url = data.domain;
        this.default_language = data.default_language;
        this.languages = WebsiteTableRow.sortLanguages(data.languages || [], data.default_language);
        this.customer = data.customer;
        this.active = data.active || true;
        this.api_key = data.api_key;
    }

    // Sort on the stored 'order', with the default language always first (it can't be dragged)
    static sortLanguages(languages, defaultLanguage) {
        return [...languages]
            .sort((a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER))
            .map(language => typeof language === 'string' ? language : language.language)
            .sort((a, b) => (b === defaultLanguage) - (a === defaultLanguage));
    }

    /*constructor(id, name, url, languages, customer, active = true, api_key = null) {
        this.id = id;
        this.name = name;
        this.url = url;
        this.languages = languages;
        this.customer = customer;
        this.active = active;
        this.api_key = api_key;
    }*/
}

export default WebsiteTableRow;